<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      :title="title"
      width="800px"
      top="5vh"
  >
    <table-select
        :filter="filter"
        :columns="columns"
        module="basic"
        url="fm/calendarMain"
        @select="selectCalendar"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter">
          <el-form-item label="日历编码">
            <el-input v-model.trim="filter.calendarCode" placeholder="请输入日历编码" clearable/>
          </el-form-item>
          <el-form-item label="日历名称">
            <el-input v-model.trim="filter.calendarName" placeholder="请输入日历名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    name: "CalendarSelect",
    components: { TableSelect },
    props: {
      title: {
        type: String,
        default: "选择日历",
      },
      // 额外过滤条件（如 { calendarType: 5 } 仅班组日历）
      filter: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        dialogVisible: false,
        columns: [
          { title: "日历编码", key: "calendarCode", width: 140, align: "center" },
          { title: "日历名称", key: "calendarName" },
          { title: "工厂编码", key: "plantCode", width: 130, align: "center" },
          { title: "操作", slot: "action", width: 80, align: "center" },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      selectCalendar(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },
      resetHandle(filter) {
        this.$emit("reset", filter);
      },
    },
  };
</script>
